export default __webpack_public_path__ + "static/media/luke-griffiths.38de7493.webp";